(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * 
	 * 
	 * @description
	 * 
	 */
	angular
	.module('paxMessage')
	.directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
	.controller('PaxMessageCtrl', PaxMessageCtrl);

	function PaxMessageCtrl(applicationConstants, CommonMasterData,
			MessageService, EventManagerService, PaxMessageService,
			PopupManager,StorageServices,TabService, AirportService) {

		var vm = this;
		vm.ctrlName = 'PaxMessageCtrl';

		vm.model = {
			searchOnGoing : false,
			searchPanelToggle : true,
			initialSearchDone : false,
			editorMode : applicationConstants.EDITOR_STATUS.ADD,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				flightNumber:null,
				country : null,
				responseStatus : null,
				crewStatus : null
			},
			masterList : {
				isBatchCodeEditable : true,
				countries : [],
				responseStatusList : [],
				crewStatusList : []
			},
			paxMsgList : [],
			selectedFlifgtNo : null,
			isElasticLoadingVisible : false,
			showBottomPanel : false,
			historyData : [],
			crewList : [],
			selectedRow:[],
			viewCrewData:false,
			rowSelected:false
		};

    	EventManagerService.registerEventListener(EventManagerService.EVENT.DO_REFRESH, refreshCrewData);

		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		vm.searchByOptions = function(searchParams) {
			searchPaxMessages();
			vm.model.viewCrewData = false;
			vm.model.showBottomPanel = false;

		};

		vm.clickOnBottomPanelView = function() {
			vm.model.showBottomPanel = !vm.model.showBottomPanel;
		}
		
		vm.changeSearchField = function(searchParams, flag) {
			 if (flag === "fromDate") {
				var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
             	if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
             		searchParams.toDate = tempFromDate;                		
             	}
			}
			 
			 if (flag === "toDate") {
				 var dateFrom = moment(searchParams.fromDate,'DD/MM/YYYY');
				 var dateTo = moment(searchParams.toDate,'DD/MM/YYYY');
	             if (dateFrom > dateTo) {
	             		searchParams.fromDate = searchParams.toDate;                		
	             }
			}
			 
		};

		vm.selectFlRow = function(row,flag) {
			vm.model.showBottomPanel = true;
			vm.model.selectedFlifgtNo = row.flightNo;
			vm.model.crewList = row.paxMsgCrew;
			vm.model.historyData = row.history;
			vm.model.historyData.journeyHistory = row.journeyHistory;
			vm.model.historyData.responceDet = row.responceDet;
			vm.model.selectedRow = row;
			vm.model.viewCrewData = true;
			vm.model.rowSelected =true;
			
			if(flag==='send'){
				sendPaxMessages(row);
			}
		};

		vm.reSubmit = function() {
			var reSubmit = PaxMessageService.setResubmitData(vm.model.selectedRow);
			PaxMessageService.reSubmit(function() {
				MessageService.success('Successfully Submitted!!');
				refreshCrewData();
			}, function(error) {
				MessageService.error(error);
			});

		};
		vm.selectCrewRow = function(r, flag) {

			if (flag === 'row') {
				var newList = [];
				angular.forEach(vm.model.crewList, function(crew) {
					if (crew.crewProfId === r.crewProfId) {
						crew.isSelected = r.isSelected ? false : true;
					}
					newList.push(crew);
				});
				vm.model.crewList = newList;
			}
			if (flag === 'swap') {
				swapCrew(r);
			}
			if (flag === 'override') {
				overrideCrew(r);
			}
			
			if(flag === 'viewSchedule'){
				viewCrewSchedule(r);
			}
			
			if(flag === 'resubmitCnx'){
				resubmitCancel(r);
			}
				
		};

		function searchPaxMessages() {
			PaxMessageService
					.setPaxMessageSearchCriteria(vm.model.searchCriteria);
			PaxMessageService.getPaxMessages(function(paxMsgList) {
				vm.model.paxMsgList = paxMsgList;
				vm.model.searchPanelToggle = false;
				vm.model.searchOnGoing = false;
			}, function(error) {
				MessageService.error(error);
			});
		}

		function swapCrew() {

		};

		function overrideCrew(crewRow) {
			var param = {};
			param.paxMsgJourneyCrewId = crewRow.paxMsgJourneyCrewId;
			param.paxMsgSchdId = vm.model.selectedRow.paxMsgSchdId; 
			param.overideCode = crewRow.overideCode;
			PopupManager.openModal('PAX_MSG_OVERRIDE', param, onSendAlertClose);
			
		}
		
		function refreshCrewData(){
			vm.model.paxMsgList =[];
			vm.model.crewList =[];
			PaxMessageService.getPaxMessages(function(paxMsgList) {
				vm.model.paxMsgList = paxMsgList;
				vm.model.searchPanelToggle = false;
				vm.model.searchOnGoing = false;
				angular.forEach(vm.model.paxMsgList, function(pax) {
					if(pax.paxMsgSchdId === vm.model.selectedRow.paxMsgSchdId){
						vm.model.viewCrewData = true;
						vm.model.crewList = pax.paxMsgCrew;
						vm.model.selectedRow = pax;
					}	
				});
				
			}, function(error) {
				MessageService.error(error);
			});	
		}
		
		function viewCrewSchedule(rowData){
			var tabName = 'crewSchedule';
            var mo = moment(vm.model.selectedRow.depDate, applicationConstants.SETTINGS.DATE_FORMAT);
            var moStart = moment(mo.startOf("month"));
            var moEnd = moment(mo.endOf("month"));
            var crewId = rowData.crewId;
            
            StorageServices.setTabData(tabName, 'crewingParams', {
                crewId: crewId,
                fromDate: moStart.format(applicationConstants.SETTINGS.DATE_FORMAT),
                toDate: moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT)
            });
            TabService.gotoTab(tabName, {
                crewId: crewId
            });			
		};
		
		function sendPaxMessages(rowData){
			PaxMessageService.setManualySendAppData(rowData);
			PaxMessageService.manualySendApp(function() {
				MessageService.success('Successfully Submitted!!');
				refreshCrewData();
			}, function(error) {
				MessageService.error(error);
			});	
		};
		
		function resubmitCancel(rowData){
			PaxMessageService.resubmitCancel(rowData,function() {
				MessageService.success('Successfully Submitted!!');
				refreshCrewData();
			}, function(error) {
				MessageService.error(error);
			});
		};
		
		function onSendAlertClose(pass) {

		}
		
		AirportService.searchCountries(function(countries) {
			vm.model.masterList.countries = countries;
		}, function(error) {
			MessageService.error(error);
		});
		
		CommonMasterData.getResponseStatusList(function(responseStatusList) {
			vm.model.masterList.responseStatusList = responseStatusList;
		}, function(error) {
			MessageService.error(error);
		});
		
		CommonMasterData.getCrewStatusList(function(crewStatusList) {
			vm.model.masterList.crewStatusList = crewStatusList;
		}, function(error) {
			MessageService.error(error);
		});
	}
}());